export default __webpack_public_path__ + "static/media/bihada-factory-brandstory.a08868b9.jpg";